import { Images } from '../../config/images';

export const headerData = {
  image: Images.thewellington,
  name: 'The Cooper',
  location: 'Lincoln, MA',
  type: 'Vacation rental',
};

export const summaryData = {
  currentPrice: '$43.21',
  change: 'loss',
  changeValue: '-$1.02',
  changePercentage: '2.15%',
  duration: 'prev 30d',
  points: [
    {
      label: 'Best ask',
      value: 'lowestAsk',
      prefix: '$',
    },
    {
      label: 'Best bid',
      value: 'highestBid',
      prefix: '$',
    },
    {
      label: '52 week low',
      value: 'low52week',
      prefix: '$',
    },
    {
      label: '52 week high',
      value: 'high52week',
      prefix: '$',
    },
    {
      label: 'Last dividend',
      tooltip: 'The last dividend per share paid at the start of the most recent quarter.',
      value: 'lastDividend',
    },
    {
      label: 'Next dividend',
      value: 'nextDividendDate',
    },
  ],
  dataSource: [
    {
      key: '1',
      name: 'The Cooper',
      prevone: <span className='text-success'>122%</span>,
      prevthree: <span className='text-success'>286.4%</span>,
      alltime: <span className='text-success'>432.1%</span>,
    },
    {
      key: '2',
      name: 'Lincoln, MA',
      prevone: <span className='text-error'>-0.9%</span>,
      prevthree: <span className='text-success'>4.2%</span>,
      alltime: <span className='text-success'>8.9%</span>,
    },
  ],
  columns: [
    {
      dataIndex: 'name',
      key: 'name',
      fixed: 'left',
    },
    {
      title: 'prev 1 years',
      dataIndex: 'prevone',
      key: 'prevone',
      align: 'right',
    },
    {
      title: 'prev 3 years',
      dataIndex: 'prevthree',
      key: 'prevthree',
      align: 'right',
    },
    {
      title: 'since initial offering',
      dataIndex: 'alltime',
      key: 'alltime',
      align: 'right',
    },
  ],
};

export const orderData = {
  blocks: [
    {
      label: 'Last price traded',
      value: 'lastPriceTraded',
      prefix: '$',
    },
    {
      label: 'Total trade volume (last 4w)',
      value: 'totalTradeVolume',
      prefix: '$',
    },
  ],
  buy: [
    {
      price: '$46.99',
      quantity: '1 share',
    },
    {
      price: '$45.68',
      quantity: '9 shares',
    },
    {
      price: '$45.68',
      quantity: '5 shares',
    },
    {
      price: '$45.68',
      quantity: '1 share',
    },
    {
      price: '$45.68',
      quantity: '2 shares',
    },
  ],
  sell: [
    {
      price: '$49.00',
      quantity: '11 shares',
    },
    {
      price: '$49.90',
      quantity: '27 shares',
    },
    {
      price: '$49.90',
      quantity: '48 shares',
    },
    {
      price: '$49.90',
      quantity: '1100 shares',
    },
    {
      price: '$49.90',
      quantity: '6 shares',
    },
    {
      price: '$49.90',
      quantity: '6 shares',
    },
    {
      price: '$49.90',
      quantity: '226 shares',
    },
  ],
  recent: [
    {
      date: 'Jan 4',
      price: '$45.68',
      quantity: '1 share',
    },
    {
      date: 'Jan 4',
      price: '$46.99',
      quantity: '9 shares',
    },
    {
      date: 'Jan 3',
      price: '$45.68',
      quantity: '5 shares',
    },
    {
      date: 'Jan 3',
      price: '$45.68',
      quantity: '5 shares',
    },
    {
      date: 'Jan 1',
      price: '$45.68',
      quantity: '2 shares',
    },
  ],
};
